import { createAsyncThunk } from "@reduxjs/toolkit";
import config from "../../config";
import axiosClient from "../../common/api/request";

const rejectFromError = (error, rejectWithValue) => {
  if (
    error?.response &&
    error?.response?.data &&
    typeof error?.response?.data === "object"
  ) {
    return rejectWithValue(error?.response?.data);
  }
  return rejectWithValue({ Error: error?.message });
};

export const getComparePanels = createAsyncThunk(
  "comparePanel/get",
  async (_params, { rejectWithValue }) => {
    try {
      const data = await axiosClient.get(
        `${config.API_URL_V2}/compare_panels/`
      );
      return data;
    } catch (error) {
      return rejectFromError(error, rejectWithValue);
    }
  }
);

export const postComparePanel = createAsyncThunk(
  "comparePanel/post",
  async (params, { rejectWithValue }) => {
    try {
      const data = await axiosClient.post(
        `${config.API_URL_V2}/compare_panels/`,
        { report_id: params?.report_id }
      );
      // Re-attach _localId so the slice / hook can match the placeholder.
      return { ...data, _localId: params?._localId };
    } catch (error) {
      return rejectFromError(error, rejectWithValue);
    }
  }
);

export const patchComparePanel = createAsyncThunk(
  "comparePanel/patch",
  async (params, { rejectWithValue }) => {
    try {
      const data = await axiosClient.patch(
        `${config.API_URL_V2}/compare_panels/${params?.id}/`,
        { report_id: params?.report_id }
      );
      return data;
    } catch (error) {
      return rejectFromError(error, rejectWithValue);
    }
  }
);

export const deleteComparePanel = createAsyncThunk(
  "comparePanel/delete",
  async (params, { rejectWithValue }) => {
    try {
      await axiosClient.delete(
        `${config.API_URL_V2}/compare_panels/${params?.id}/`
      );
      return { id: params?.id };
    } catch (error) {
      return rejectFromError(error, rejectWithValue);
    }
  }
);

export const getComparePanelsAiAdvice = createAsyncThunk(
  "comparePanel/aiAdvice",
  async (params, { rejectWithValue }) => {
    try {
      return await axiosClient.post(
        `${config.API_URL_V2}/compare_panels/ai_advice/`,
        params
      );
    } catch (error) {
      const status = error?.response?.status;
      const data = error?.response?.data;
      if (data && typeof data === "object") {
        return rejectWithValue({ ...data, status });
      }
      return rejectWithValue({ Error: error?.message, status });
    }
  }
);
